import moment from 'moment'
import { t } from 'i18n-js'
import { ORDER_STATUSES } from '../../constants/text'
import { EU_DATE } from '../Cart/utils'

export const COLUMNS = {
  STATUS: 'STATUS',
  FAMILY_ID: 'FAMILY_ID',
  CREATED_TIME: 'CREATED_TIME',
  CREATED_DATE: 'CREATED_DATE',
  BILL_NUMBER: 'BILL_NUMBER',
  CHILD_NAME: 'CHILD_NAME',
  GROUP_NAME: 'GROUP_NAME',
  COURSE_NAME: 'COURSE_NAME',
  FAMILY_FULL_NAME: 'FAMILY_FULL_NAME',
  SERVICES_TOTAL_SUM: 'SERVICES_TOTAL_SUM',
  SERVICES_DISCOUNT_SUM: 'SERVICES_DISCOUNT_SUM',
  SERVICES_PIGGY_BANK: 'SERVICES_PIGGY_BANK',
  TO_PIGGY_BANK: 'TO_PIGGY_BANK',
  SERVICES_CASH: 'SERVICES_CASH',
  SERVICES_CARD: 'SERVICES_CARD',
  SERVICES_ONLINE_PAY: 'SERVICES_ONLINE_PAY',
  PRODUCTS_TOTAL_SUM: 'PRODUCTS_TOTAL_SUM',
  PRODUCTS_DISCOUNT_SUM: 'PRODUCTS_DISCOUNT_SUM',
  PRODUCTS_PIGGY_BANK: 'PRODUCTS_PIGGY_BANK',
  PRODUCTS_CASH: 'PRODUCTS_CASH',
  PRODUCTS_CARD: 'PRODUCTS_CARD',
  PRODUCTS_ONLINE_PAY: 'PRODUCTS_ONLINE_PAY',
  TOTAL: 'TOTAL',
  STEMS: 'STEMS',
  ADMIN_FULL_NAME: 'ADMIN_FULL_NAME'
}

// export const COLUMN_NAMES = {
//   [COLUMNS.STATUS]: t('Finances.status'),
//   // [COLUMNS.ORDER_NUMBER]: t('Finances.orderNumber'),
//   [COLUMNS.FAMILY_ID]: t('Finances.familyId'),
//   [COLUMNS.CREATED_TIME]: t('Finances.createdTime'),
//   [COLUMNS.CREATED_DATE]: t('Finances.createdDate'),
//   [COLUMNS.BILL_NUMBER]: t('Finances.billNumber'),
//   [COLUMNS.FAMILY_FULL_NAME]: t('Finances.familyFullName'),
//   [COLUMNS.SERVICES_TOTAL_SUM]: t('Finances.servicesTotalSum'),
//   [COLUMNS.SERVICES_DISCOUNT_SUM]: t('Finances.servicesDiscountSum'),
//   [COLUMNS.SERVICES_PIGGY_BANK]: t('Finances.servicesPiggyBank'),
//   [COLUMNS.SERVICES_CASH]: t('Finances.servicesCash'),
//   [COLUMNS.SERVICES_CARD]: t('Finances.servicesCard'),
//   [COLUMNS.SERVICES_ONLINE_PAY]: t('Finances.servicesOnlinePay'),
//   [COLUMNS.PRODUCTS_TOTAL_SUM]: t('Finances.productsTotalSum'),
//   [COLUMNS.PRODUCTS_DISCOUNT_SUM]: t('Finances.productsDiscountSum'),
//   [COLUMNS.PRODUCTS_PIGGY_BANK]: t('Finances.productsPiggyBank'),
//   [COLUMNS.PRODUCTS_CASH]: t('Finances.productsCash'),
//   [COLUMNS.PRODUCTS_CARD]: t('Finances.productsCard'),
//   [COLUMNS.PRODUCTS_ONLINE_PAY]: t('Finances.productsOnlinePay'),
//   [COLUMNS.TOTAL]: t('Finances.total'),
//   [COLUMNS.STEMS]: t('Finances.stems'),
//   [COLUMNS.ADMIN_FULL_NAME]: t('Finances.adminFullName'),
// };

// The field each column reads from an order. Kept beside COLUMNS so the Excel export writes the same values the
// table shows, instead of re-deriving them from the column definitions.
export const COLUMN_ACCESSORS = {
  [COLUMNS.STATUS]: 'status',
  [COLUMNS.CREATED_DATE]: 'createDate',
  [COLUMNS.CREATED_TIME]: 'createTime',
  [COLUMNS.BILL_NUMBER]: 'orderNumber',
  [COLUMNS.CHILD_NAME]: 'studentName',
  [COLUMNS.GROUP_NAME]: 'groupName',
  [COLUMNS.COURSE_NAME]: 'courseName',
  [COLUMNS.FAMILY_FULL_NAME]: 'mainParentName',
  [COLUMNS.FAMILY_ID]: 'familyId',
  [COLUMNS.SERVICES_TOTAL_SUM]: 'serviceSum',
  [COLUMNS.SERVICES_DISCOUNT_SUM]: 'serviceDiscountSum',
  [COLUMNS.SERVICES_PIGGY_BANK]: 'serviceSpentFromDeposit',
  [COLUMNS.TO_PIGGY_BANK]: 'depositAmount',
  [COLUMNS.SERVICES_CASH]: 'serviceCash',
  [COLUMNS.SERVICES_CARD]: 'serviceCard',
  [COLUMNS.SERVICES_ONLINE_PAY]: 'serviceOnline',
  [COLUMNS.PRODUCTS_TOTAL_SUM]: 'productSum',
  [COLUMNS.PRODUCTS_DISCOUNT_SUM]: 'productDiscountSum',
  [COLUMNS.PRODUCTS_PIGGY_BANK]: 'productSpentFromDeposit',
  [COLUMNS.PRODUCTS_CASH]: 'productCash',
  [COLUMNS.PRODUCTS_CARD]: 'productCard',
  [COLUMNS.PRODUCTS_ONLINE_PAY]: 'productOnline',
  [COLUMNS.TOTAL]: 'totalSum',
  [COLUMNS.STEMS]: 'spentFromStem',
  [COLUMNS.ADMIN_FULL_NAME]: 'adminName'
}

// Columns the summary row totals. Listed explicitly rather than sniffed from the values, because familyId is a
// number too and must never be summed.
export const MONEY_ACCESSORS = [
  'serviceSum',
  'serviceDiscountSum',
  'serviceSpentFromDeposit',
  'depositAmount',
  'serviceCash',
  'serviceCard',
  'serviceOnline',
  'productSum',
  'productDiscountSum',
  'productSpentFromDeposit',
  'productCash',
  'productCard',
  'productOnline',
  'totalSum',
  'spentFromStem'
]

export const COLUMN_NAMES = {
  [COLUMNS.STATUS]: t(
    'Finances.status'), // [COLUMNS.ORDER_NUMBER]: t('Finances.orderNumber'),
  [COLUMNS.FAMILY_ID]: t('Finances.familyId'),
  [COLUMNS.CREATED_TIME]: t('Finances.createdTime'),
  [COLUMNS.CREATED_DATE]: t('Finances.createdDate'),
  [COLUMNS.BILL_NUMBER]: t('Finances.billNumber'),
  [COLUMNS.CHILD_NAME]: t('Finances.childName'),
  [COLUMNS.GROUP_NAME]: t('Finances.groupName'),
  [COLUMNS.COURSE_NAME]: t('Finances.courseName'),
  [COLUMNS.FAMILY_FULL_NAME]: t('Finances.familyFullName'),
  [COLUMNS.SERVICES_TOTAL_SUM]: t('Finances.servicesTotalSum'),
  [COLUMNS.SERVICES_DISCOUNT_SUM]: t('Finances.servicesDiscountSum'),
  [COLUMNS.SERVICES_PIGGY_BANK]: t('Finances.servicesPiggyBank'),
  [COLUMNS.TO_PIGGY_BANK]: t('Finances.toPiggyBank'),
  [COLUMNS.SERVICES_CASH]: t('Finances.servicesCash'),
  [COLUMNS.SERVICES_CARD]: t('Finances.servicesCard'),
  [COLUMNS.SERVICES_ONLINE_PAY]: t('Finances.servicesOnlinePay'),
  [COLUMNS.PRODUCTS_TOTAL_SUM]: t('Finances.productsTotalSum'),
  [COLUMNS.PRODUCTS_DISCOUNT_SUM]: t('Finances.productsDiscountSum'),
  [COLUMNS.PRODUCTS_PIGGY_BANK]: t('Finances.productsPiggyBank'),
  [COLUMNS.PRODUCTS_CASH]: t('Finances.productsCash'),
  [COLUMNS.PRODUCTS_CARD]: t('Finances.productsCard'),
  [COLUMNS.PRODUCTS_ONLINE_PAY]: t('Finances.productsOnlinePay'),
  [COLUMNS.TOTAL]: t('Finances.total'),
  [COLUMNS.STEMS]: t('Finances.stems'),
  [COLUMNS.ADMIN_FULL_NAME]: t('Finances.adminFullName')
}

export const ORDER_STATUSES_NAMES = {
  [ORDER_STATUSES.ACTIVE]: t('Finances.statusActive'),
  [ORDER_STATUSES.IN_PROCESS]: t('Finances.statusInProgress'),
  [ORDER_STATUSES.PAID]: t('Finances.statusPaid'),
  [ORDER_STATUSES.ARCHIVED]: t('Finances.statusArchive'),
  [ORDER_STATUSES.EDITED]: t('Finances.statusEdited'),
  [ORDER_STATUSES.ONLINE]: t('Finances.statusOnline')
}

// Floats out of JSON accumulate noise (0.1 + 0.2), so every total is rounded back to kopiykas.
export const sumColumn = (rows, dataIndex) => Math.round(rows.reduce(
  (total, row) => total + (Number(row[dataIndex]) || 0), 0) * 100) / 100

/**
 * Builds the totals row the export closes with, mirroring the table's summary: the row count under the first
 * column, a sum under every money column, and nothing under the rest.
 *
 * @param {Array.<Object>} orders orders being exported
 * @param {Array.<String>} showingColumns COLUMNS keys currently rendered
 * @returns {Object} one row keyed by localized column title
 */
const buildOrdersTotalsRow = (orders, showingColumns) =>
  showingColumns.reduce((row, column, index) => {
    const accessor = COLUMN_ACCESSORS[column]
    if (index === 0) {
      row[COLUMN_NAMES[column]] = `${t('Finances.summaryTotal')} (${orders.length})`
    } else {
      row[COLUMN_NAMES[column]] = MONEY_ACCESSORS.includes(accessor)
        ? sumColumn(orders, accessor)
        : null
    }
    return row
  }, {})

/**
 * Turns orders into the plain objects exportToXls expects, one key per visible column, closing with a totals row.
 *
 * Values are formatted the way the table renders them — a translated status, a DD.MM.YYYY date — so the file reads
 * like what is on screen rather than like the API payload. Columns keep the order the caller lists them in.
 *
 * @param {Array.<Object>} orders orders to export, already filtered and sorted by the table
 * @param {Array.<String>} showingColumns COLUMNS keys currently rendered
 * @returns {Array.<Object>} rows keyed by localized column title, the last one being the totals
 */
export const buildOrdersExportRows = (orders, showingColumns) => {
  if (!orders.length) {
    return []
  }

  const rows = orders.map(order => showingColumns.reduce((row, column) => {
    const value = order[COLUMN_ACCESSORS[column]]
    if (column === COLUMNS.STATUS) {
      row[COLUMN_NAMES[column]] = ORDER_STATUSES_NAMES[value] || value
    } else if (column === COLUMNS.CREATED_DATE) {
      row[COLUMN_NAMES[column]] = value ? moment(value).format(EU_DATE) : null
    } else {
      row[COLUMN_NAMES[column]] = value
    }
    return row
  }, {}))

  return [...rows, buildOrdersTotalsRow(orders, showingColumns)]
}
